import workspaceQuery from 'graphql/queries/purchases/PurchaseRequirementDetailPreviewWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/purchases/PurchaseRequirementDetailFragment.graphql';

const PurchaseRequirementDetailPreview = {
  type: 'PurchaseRequirementDetailPreview',
  title: 'Sales Order Shortages',
  workspaceUrl: '/Purchasing/Shortages/ShortageDetailPreview/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'SHORTAGES_PREVIEW',
  actions: [
    {
      description: 'Add to Shortage List',
      actionReference: 'PURCHASING_ORDERS_CREATE',
    },
    {
      description: 'Raise Direct Delivery Order',
      actionReference: 'PURCHASING_ORDERS_CREATE',
    },
    {
      description: 'Raise Back to Back Order',
      actionReference: 'PURCHASING_ORDERS_CREATE',
    },
  ],
};

export default PurchaseRequirementDetailPreview;
